export default __webpack_public_path__ + "static/media/size_shirt.e640f886.png";